import { render, staticRenderFns } from "./ExportManuscriptDialog.vue?vue&type=template&id=5cf0148e&scoped=true"
import script from "./ExportManuscriptDialog.vue?vue&type=script&lang=ts"
export * from "./ExportManuscriptDialog.vue?vue&type=script&lang=ts"
import style0 from "./ExportManuscriptDialog.vue?vue&type=style&index=0&id=5cf0148e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf0148e",
  null
  
)

export default component.exports